<template>
  <div :class="[loadingCompleted && expirePoint ? 'd-flex' : 'd-none']" class="px-3 py-2 align-items-center justify-content-between text-white bg-customize font-size-md">
    <div>
      {{ deadlineHint }}
    </div>
    <a href="javascript: void(0)" class="text-white" @click="$router.push({ name: 'redeemList', query: { companyid: $store.state.companyId, membersourceid: $store.state.memberSourceId }});">
      <span class="material-icons">
        keyboard_arrow_right
      </span>
    </a>
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';
import dateTimeFormatter from '@/utils/dateTimeFormatter';
import currency from '@/filters/currency';

export default {
  data() {
    return {
      // 資料是否完成載入
      loadingCompleted: false,
      // 即將過期積點
      expirePoint: 0,
      // 即將過期日期
      expireDate: null,
      // 積點單位
      pointUnit: '',
      // 過期提醒文案
      deadlineHintWording: '',
    };
  },
  computed: {
    // 過期提醒
    deadlineHint() {
      const vm = this;
      if (vm.loadingCompleted && vm.expireDate) {
        const pointDeadline = dateTimeFormatter.formatDate(vm.expireDate, '/', true);
        return vm.deadlineHintWording
          .replace(/{UserPoint}/igm, currency(vm.expirePoint))
          .replace(/{PointUnit}/igm, vm.pointUnit)
          .replace(/{PointDeadline}/igm, pointDeadline);
      }
      return '';
    },
  },
  created() {
    const vm = this;
    // 取得頁面設定資料
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'UserPointHistory');
    getPageSetting.then((setting) => {
      vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
      vm.deadlineHintWording = pageSettingGetter.getFunctionWording(setting, 'UserPointDeadlineWording');
    });
    // 取得會員積點
    const getMemberBonus = vm.$store.dispatch('getMemberBonus');
    getMemberBonus.then((memberBonus) => {
      if (memberBonus.summary.length === 0) return;

      const firstExpired = memberBonus.summary.reduce((first, current) => (Date.parse(first.pointExpiry) < Date.parse(current.pointExpiry) ? first : current));
      const expireDate = dateTimeFormatter.parseTaiwanDateTime(firstExpired.pointExpiry);
      // 若最近過期時間在2099/12/31以後，不需顯示
      if (expireDate.getFullYear() >= 2099) return;
      vm.expirePoint = firstExpired.point - firstExpired.pointUsed;
      vm.expireDate = expireDate;
    });
    Promise.all([getPageSetting, getMemberBonus])
      .then(() => { vm.loadingCompleted = true; });
  },
};
</script>
